import { useDatastore } from './useDatastore';

// A model counts as "ready" if it has finished its own base sync, or if the whole
// datastore reports ready (backstop for zero-record models that never emit modelSynced).
export function useModelReady(modelName: string): boolean {
  const { modelReadiness, isDatastoreReady } = useDatastore();
  return isDatastoreReady || modelReadiness?.[modelName] === true;
}
